/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';

export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: Array<CodeBlock> = [];
    if (!feature.getEnabled()) {
        return blocks;
    }
    const BTENABLED = feature.getSettingValue('BTENABLED') === '1';
    const START_ENABLED = feature.getSettingValue('START_ENABLED') === '1';


    blocks.push({
        location: 'GLOBAL_DEFINES',
        blockType: BlockType.CODE,
        template: `
#define LUIS_CONFIG_FILE "luis.xtxt"
#define LUIS_DEBUG_PRINT 1`,
    });

    blocks.push({
        location: 'on_bt_event',
        blockType: BlockType.CODE,
        template: `
    luis_on_bt_event(bt_event)`,
    });
    blocks.push({
        location: 'on_bt_data_sent',
        blockType: BlockType.CODE,
        template: `
    luis_on_bt_data_sent()`,
    });
    blocks.push({
        location: 'on_bt_data_arrival',
        blockType: BlockType.CODE,
        template: `
    if luis_bt_enabled = true then
        luis_on_bt_data_arrival()
    end if`,
    });

    blocks.push({
        location: 'boot',
        blockType: BlockType.CODE,
        template: `
    luis_start(BT_NAME)
    luis_bt_enabled = ${BTENABLED}`,
    });

    if (START_ENABLED) {
        blocks.push({
            location: 'boot',
            blockType: BlockType.CODE,
            template: `
    'enable the BLE interface and wait for it to become enabled
    '(blocking version)
    bt.enable()
    dim bt_wait as dword=sys.timercountms + 4000
    while bt.enabled=NO AND sys.timercountms < bt_wait
    wend
    if bt.enabled=NO then
        sys.debugprint("Bluetooth failed to boot")
    else
        bt.advertise=YES 'allow the device to be discoverable
    end if`,
        });
    }

    blocks.push({
        location: 'GLOBAL_DECLARATIONS',
        blockType: BlockType.CODE,
        template: `
declare luis_bt_enabled as boolean`,
    });

    blocks.push({
        location: 'GLOBAL_DIMS',
        blockType: BlockType.CODE,
        template: `
dim luis_bt_enabled as boolean`,
    });

    if (feature.getSettingValue('WEBENABLED') === '1') {
        blocks.push({
            location: 'boot',
            blockType: BlockType.CODE,
            template: `
        '================================================================
        'sys.debugprint("go to http://" + net.ip + "/settings_web.html in the browser to see the home page\\r\\n")
        '-----------------------------------------------------------------`,
        });
    }

    blocks.push({
        location: 'DEVICE_TBS',
        blockType: BlockType.LOCATION,
        id: 'callback_luis_bt_connected',
        template: `
sub callback_luis_bt_connected()
    '****callback_luis_bt_connected****'
end sub
        `,
    });

    blocks.push({
        location: 'DEVICE_TBS',
        blockType: BlockType.LOCATION,
        id: 'callback_luis_bt_disconnected',
        template: `
sub callback_luis_bt_disconnected()
    '****callback_luis_bt_disconnected****'
end sub
        `,
    });

    blocks.push({
        location: 'DEVICE_TBS',
        blockType: BlockType.LOCATION,
        id: 'callback_luis_bt_enabled',
        template: `
sub callback_luis_bt_enabled()
    '****callback_luis_bt_enabled****'
end sub
        `,
    });

    blocks.push({
        location: 'DEVICE_TBS',
        blockType: BlockType.LOCATION,
        id: 'callback_luis_bt_disabled',
        template: `
sub callback_luis_bt_disabled()
    '****callback_luis_bt_disabled****'
end sub
        `,
    });


    blocks.push({
        location: 'DEVICE_TBS',
        blockType: BlockType.CODE,
        template: `
function callback_luis_read(byref name as string, byref value as string) as boolean
    callback_luis_read=false
    '****callback_luis_read****'
end function`,
    });

    blocks.push({
        location: 'DEVICE_TBS',
        blockType: BlockType.CODE,
        template: `
function callback_luis_write(byref name as string, byref value as string) as boolean
    callback_luis_write=false
    '****callback_luis_write****'
end function`,
    });

    const settingsFile = '';
    let tmpBlocks: Array<CodeBlock> = [];
    const groups = feature.getSettingValue('GROUPS');
    const sdfFile = '';
    let luisFile = '';
    const menuFile = '';
    for (let i = 0; i < groups.length; i += 1) {
        const group = groups[i];
        tmpBlocks = tmpBlocks.concat(group.getCodeBlocks());
    }
    for (let i = 0; i < tmpBlocks.length; i += 1) {
        switch (tmpBlocks[i].location) {
            case 'luis.xtxt':
                luisFile += tmpBlocks[i].template;
                break;
            default:

                break;
        }
    }

    luisFile += `
@@STG_RefPath=settings.xtxt`;

    blocks.push({
        location: 'LUIS_XTXT',
        blockType: BlockType.CODE,
        template: luisFile,
    });

    return blocks;
};
